import moment from "moment"

function formatPrice(number) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(
    number,
  )
}

function formatDateTime(t) {
  return moment(new Date(t)).format('HH:mm:ss DD-MM-YYYY')
}

export {
  formatPrice,
  formatDateTime
}
